import {   Text, TextStyle } from 'pixi.js';
import { translate } from 'game/translate';
import { GameEvent } from 'game/events/gameEvent';
import { EventName } from 'game/events/eventsName';

export class TranslationText {
    text: Text;
    private translationKey: string;

    constructor(text: string, style: TextStyle) {
        this.translationKey = text;
        this.translate = this.translate.bind(this);
        this.text = new Text({ text: translate(text), style });

        GameEvent.add(EventName.CHANGE_LANGUAGE, this.translate);
    }
    translate() {
        this.text.text = translate(this.translationKey);
    }
    getText() {
        return this.text.text;
    }
    setKey(translationKey: string) {
        this.translationKey = translationKey;
        this.translate();
    }
    setAnchor(anchorX: number, anchorY?: number) {
        if (!anchorY && anchorY !== 0) anchorY = anchorX;
        this.text.anchor.set(anchorX, anchorY);
    }

    getSize() {
        return this.text.getBounds();
    }
}
